var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "p-4 bg-gray-100" },
    [
      _c(
        "div",
        { staticClass: "inline-flex" },
        [
          _c("router-link", { attrs: { to: { name: _vm.pathing } } }, [
            _c("h3", { staticClass: "pt-4 pl-8 mr-2 text-gray-500" }, [
              _vm._v(" " + _vm._s(_vm.naming) + " "),
            ]),
          ]),
          _c("h3", { staticClass: "pt-4 mr-2" }, [_vm._v("InPro Groups")]),
        ],
        1
      ),
      _c(
        "page-layout",
        [
          _vm.searchService
            ? _c(
                "async-table-component",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        isSortable: true,
                        isFilterable: true,
                        localStorageKey: "InPro-class-collection-table",
                        emptyTableMessage: "0 classes",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "settings-right",
                            fn: function () {
                              return [
                                _c(
                                  "button-component",
                                  {
                                    attrs: {
                                      "data-cy": "createInProClassButton",
                                      bg: "val-button-blue",
                                      textOrBorderColor: "white",
                                    },
                                    on: { click: _vm.createClass },
                                  },
                                  [_vm._v(" Add Class ")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4266196523
                      ),
                    },
                    "async-table-component",
                    _vm.searchService.tableProps,
                    false
                  ),
                  _vm.searchService.tableEventListeners
                )
              )
            : _vm._e(),
          _c("in-processing-class-modal-component", {
            ref: "InProClassModal",
            attrs: { size: "medium" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }